import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Stethoscope, Loader2, HeartPulse } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ClinicLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user && ["CLINIC_STAFF", "ADMIN"].includes(user.role)) return <Navigate to="/clinic" replace />;
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await login(email, password, "clinic"); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen bg-[#F2F4F1] text-neutral-800 lg:grid-cols-2">
      <div className="relative hidden overflow-hidden rounded-r-[48px] bg-[#232323] p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#1F9E7A]" />
        <div className="absolute -bottom-16 left-24 h-48 w-48 rounded-full bg-[#F5E04F]" />
        <div className="relative flex items-center gap-2"><div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F5E04F] text-[#151515]"><Stethoscope className="h-5 w-5" /></div><span className="font-display text-lg font-bold">Rahmat Clinic</span></div>
        <div className="relative max-w-md">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#F5E04F]">Patient Register</p>
          <h1 className="font-display mt-4 text-4xl font-bold leading-tight lg:text-5xl">Every patient, every visit, one register.</h1>
          <p className="mt-5 text-white/70">Register patients in seconds, see monthly counts by doctor, and download the month in Excel.</p>
        </div>
        <p className="relative flex items-center gap-2 font-mono text-xs text-white/60"><HeartPulse className="h-4 w-4" />Dr. Lari · Dr. Nazia · Dr. Afzal</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} data-testid="clinic-login-form" className="w-full max-w-sm space-y-5">
          <div className="flex items-center gap-2 lg:hidden"><div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#232323] text-[#F5E04F]"><Stethoscope className="h-5 w-5" /></div><span className="font-display text-lg font-bold">Rahmat Clinic</span></div>
          <div><h2 className="font-display text-2xl font-bold text-[#151515]">Clinic staff sign in</h2><p className="mt-1 text-sm text-neutral-500">Use your Rahmat Clinic account.</p></div>
          <Input data-testid="clinic-login-email" type="email" required placeholder="Clinic email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-full bg-white px-5" />
          <Input data-testid="clinic-login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-full bg-white px-5" />
          {err && <p data-testid="clinic-login-error" className="text-sm text-rose-600">{err}</p>}
          <Button data-testid="clinic-login-submit" disabled={busy} className="h-12 w-full rounded-full bg-[#232323] text-base text-white hover:bg-black">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}</Button>
          <Link to="/login" data-testid="clinic-to-crm-link" className="block text-center text-xs text-neutral-500 hover:text-[#1F9E7A]">Saminfratech sales team? Sign in here</Link>
        </form>
      </div>
    </div>
  );
}
